import React from 'react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { colors } from '@styles/colors';

// Componente reutilizable para botones
const Boton = ({ label, onClick, color = colors.primary, ancho = '22.2vh', alto = '4.4vh', disabled = false, siguiente = false }) => {
  return (
    <button 
      onClick={onClick}
      disabled={disabled}
      style={{
        width: ancho,
        height: '5.3vh',
        backgroundColor: disabled ? colors.gray400 : color,
        borderRadius: '4vh',
        transform: 'rotate(0deg)',
        opacity: disabled ? 0.6 : 1,
        border: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        fontSize: '1.9vh',
        fontFamily: 'Inter',
        color: colors.primaryText,
        cursor: disabled ? 'not-allowed' : 'pointer',
        transition: 'all 0.3s ease'
      }}
    >
      <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
        {label}
      </span>
        {siguiente && (
          <ArrowForwardIcon style={{ color: colors.white, fontSize: '2.2vh', position: 'absolute', right: '1.2vh', top: '50%', transform: 'translateY(-50%)' }} />
        )}      
    </button>
  );
};

export default Boton;